// components/SessionProvider.tsx
'use client';

import { SessionProvider } from 'next-auth/react';
import { ReactNode } from 'react';

export default function SessionProviderWrapper({
  children
}: {
  children: ReactNode;
}) {
  return (
    <SessionProvider 
      // Set a much longer refetch interval to avoid disrupting active sessions
      // 3600 seconds = 1 hour
      refetchInterval={3600}
      // Disable automatic session refresh on window focus
      refetchOnWindowFocus={false}
      // Disable refetch when offline
      refetchWhenOffline={false}
    >
      {children}
    </SessionProvider>
  );
}